<template>
  <v-container fluid>
    <CategoriesList />
    <router-view name="dialog" />
  </v-container>
</template>

<script>
import CategoriesList from "./CategoriesList"

export default {
  name: "CategoriesShowView",
  props: {
    flatplanId: {
      type: String,
      required: true,
    },
  },
  components: {
    CategoriesList,
  },
}
</script>
